/*eslint no-script-url: 0 */
import React, { Component } from "react";
import { Modal } from 'react-bootstrap';
import ImageFile from './ImageFile';

class UploadImage extends Component {

	constructor(props) {
        super(props);
        this.state = {
			lgShow: false
        }
    }

	lgClose = () => {
		this.setState({ lgShow: false });
	}

	lgShow = () => {
		this.setState({ lgShow: true })
	}

 	render() {
	    return (
			<li className="m-b-5">
				<a href="#!" onClick={this.lgShow} className="btn btn-primary default-btn">Upload Image</a>
				<Modal
					show={this.state.lgShow}
					onHide={this.lgClose}
					bsSize="large"
					aria-labelledby="contained-modal-title-lg"
				>
					<Modal.Header closeButton>
			        	<Modal.Title id="contained-modal-title-lg">Upload an Image</Modal.Title>
			        </Modal.Header>
					<Modal.Body>
						<ImageFile
							{...this.props}
							lgClose={this.lgClose}
							handler={this.props.handler}
							id={this.props.id} />
					</Modal.Body>
				</Modal>
			</li>
	    );
  	}
}
export default UploadImage;